/**
 * @file FAQ Grid
 */

import { gsap } from 'gsap';

/**
	* FAQ Grid component
	*/
const vFaqGrid = () => {
	const faqGrid = document.querySelector( '.v-faq-grid' );

	if ( ! faqGrid ) {
		return;
	}

	const toggles = faqGrid.querySelectorAll( '.v-faq-grid__hz-toggle' );

	if ( ! toggles.length ) {
		return;
	}

	const query = window.matchMedia( '(max-width: 980px)' );

	/**
	 * Toggle FAQ row
	 *
	 * @param {string} row The FAQ row to toggle
	 */
	const toggleRow = ( row ) => {
		const toggle     = faqGrid.querySelector( `[data-controls-row="${ row }"]` );
		const isHidden   = toggle.getAttribute( 'aria-expanded' ) === 'false';
		const targets    = faqGrid.querySelectorAll( `[data-row="${ row }"]` );
		const heightWrap = toggle.parentElement.nextElementSibling;
		const wrapInner  = heightWrap.querySelector( '.v-faq-grid__height-wrap-inner' );
		const tl         = gsap.timeline( {
			defaults: {
				ease: 'sine.out',
			},
			onStart: () => {
				if ( ! isHidden ) {
					return;
				}

				[ ...targets ].forEach( ( target ) => {
					target.classList.remove( 'collapsed' );
				} );
			},
			onComplete: () => {
				[ ...targets ].forEach( ( target ) => {
					if ( isHidden ) {
						return;
					}

					target.classList.add( 'collapsed' );
				} );

				toggle.setAttribute( 'aria-expanded', isHidden );

				if ( isHidden ) {
					return;
				}

				const nextRow = heightWrap.nextElementSibling;
				[ ...targets ].forEach( ( target ) => {
					faqGrid.insertBefore( target, nextRow );
				} );
			},
		} );

		[ ...targets ].forEach( ( target ) => {
			wrapInner.appendChild( target );
		} );

		if ( isHidden ) {
			const height = [ ...targets ].reduce( ( acc, target ) => {
				target.classList.remove( 'collapsed' );
				const size           = target.getBoundingClientRect().height;
				target.classList.add( 'collapsed' );
				return acc + size;
			}, 0 );

			tl.to( heightWrap, {
				height,
				opacity:  1,
				duration: .3,
			} );
		} else {
			tl.to( heightWrap, {
				opacity: 0,
				height:  0,
			} );
		}
	};

	[ ...toggles ].forEach( ( toggle ) => {
		toggle.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			if ( ! query.matches ) {
				return;
			}

			const row = toggle.getAttribute( 'data-controls-row' );

			toggleRow( row );
		} );
	} );

	query.addEventListener( 'change', () => {
		if ( query.matches ) {
			return;
		}
		[ ...toggles ].forEach( ( toggle ) => {
			const row        = toggle.getAttribute( 'data-controls-row' );
			const heightWrap = toggle.parentNode.nextElementSibling;

			if ( heightWrap.hasChildNodes() ) {
				const targets = heightWrap.querySelectorAll( `[data-row="${ row }"]` );
				const nextRow = heightWrap.nextElementSibling;
				[ ...targets ].forEach( ( target ) => {
					faqGrid.insertBefore( target, nextRow );
				} );

				heightWrap.removeAttribute( 'style' );
			}
		} );
	} );
};

export default vFaqGrid;
